import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import theme from '../../../theme';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { formatDateTime } from '../../../api/date';

class DevicesList_ extends React.Component{

    handleItemSelect(itemID){
        console.log('select device '+itemID)
        this.props.onItemSelect(itemID)
    }

    getItemStyle(itemID){
        let selected = itemID === this.props.selectedItemID
        let style = {
            background: selected? theme.palette.background.selectedRow : '',
            cursor: 'pointer'
        }
        return style
    }


    sortByDate(item1, item2){
        const date1 = (item1.LoginDt!==undefined ? item1.LoginDt : item1.LoginDt)
        const date2 = (item2.LoginDt!==undefined ? item2.LoginDt : item2.LoginDt)
        if (date2 > date1) return 1;
        if (date1 === date2) return 0; 
        if (date2 < date1) return -1;
    }

    render(){

        console.log(this.props)

        const {t} = this.props

        //console.log('render devices list')
        //console.log(this.props.items)
        let items = this.props.items.sort(this.sortByDate)
        //console.log(items)

        const styles = {
            paper: {
              width: '100%',
              overflowX: 'auto',
            },
            head: {
                color: theme.palette.color.dialogTitle,
                backgroundColor: theme.palette.background.dialogTitle,
            }
        };

        return(
            <>
                <Paper style={styles.paper}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell style={styles.head}>{t('Manufacturer')}</TableCell>
                                <TableCell style={styles.head}>{t('Model')}</TableCell>
                                <TableCell style={styles.head}>{t('OS')}</TableCell>
                                <TableCell style={styles.head}>{t('Serial')}</TableCell>
                                <TableCell style={styles.head}>{t('LoginDate')}</TableCell>
                                <TableCell style={styles.head}>{t('UserName')}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        {items.map((item) => 
                            <TableRow key={item.ID} 
                                    onClick={()=>{this.handleItemSelect(item.ID)}}
                                    style={this.getItemStyle(item.ID)}>
                                <TableCell component="th" scope="row">
                                    {item.Manufacturer}
                                </TableCell>
                                <TableCell>
                                    {item.Model}
                                </TableCell>
                                <TableCell>
                                    {item.OS}
                                </TableCell>
                                <TableCell>
                                    {item.Serial}
                                </TableCell>
                                <TableCell>
                                    {formatDateTime(item.LoginDt)}
                                </TableCell>
                                <TableCell>
                                    {item.LastUserName}
                                </TableCell>
                            </TableRow>
                        )}
                        </TableBody>
                    </Table>
                </Paper>
            </>
        )

    }

}

export const DevicesList = withTranslation()(DevicesList_);